/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Nodatatitle3Inputs */

const en_coinvestments_tracking_nodatatitle3 = /** @type {(inputs: Coinvestments_Tracking_Nodatatitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tracking data available`)
};

/**
* | output |
* | --- |
* | "No tracking data available" |
*
* @param {Coinvestments_Tracking_Nodatatitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_nodatatitle3 = /** @type {((inputs?: Coinvestments_Tracking_Nodatatitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Nodatatitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_nodatatitle3(inputs)
});
export { coinvestments_tracking_nodatatitle3 as "coInvestments_tracking_noDataTitle" }